import { ReactNode } from 'react';
import { CSSProp } from 'styled-components';
import tw, { css } from 'twin.macro';

const Background = tw.div`min-h-screen flex flex-col justify-center items-center bg-no-repeat bg-cover bg-center bg-transparent`;
const AbsoluteCardContainer = tw.div`absolute flex justify-center items-start min-w-full min-h-full top-0`;
const CardOuterWrapper = tw.div`absolute w-full flex flex-col justify-start items-center bg-transparent h-full md:h-auto`;
const CardInnerWrapper = tw.div`relative w-full overflow-hidden flex flex-col justify-start items-center bg-sec-3 rounded-3xl border border-accent-muted h-full md:h-auto`;
const Card = tw.div`bg-sec-3 w-full h-full flex flex-col justify-center items-center px-[24px] md:px-[48px] py-[20px] md:py-[40px]`;

const Eclipse = tw.div`absolute w-[466px] h-[466px] rounded-full`;

const effects = css`
  background: linear-gradient(243.97deg, #7b92fb 22.93%, #7976fe 54.8%, #298eec 89.21%);
  filter: blur(132px);
`;

const Layout = ({
  children,
  header,
  backgroundCss,
  ...props
}: {
  children: ReactNode;
  header?: ReactNode;
  footer?: ReactNode;
  backgroundCss?: CSSProp;
}) => {
  return (
    <Layout.Background css={[backgroundCss]}>
      {header}
      <Layout.Card {...props}>{children}</Layout.Card>
    </Layout.Background>
  );
};

const LayoutCard = ({
  children,
  footer,
  ...props
}: {
  children: ReactNode;
  footer?: ReactNode;
}) => {
  return (
    <AbsoluteCardContainer>
      <CardOuterWrapper {...props}>
        <CardInnerWrapper>
          <Eclipse tw='left-[138px] top-[118px] z-10' css={effects} />
          <Eclipse tw='right-[138px] bottom-[118px] z-10' css={effects} />
          <Card tw='z-20'>{children}</Card>
        </CardInnerWrapper>
        {footer}
      </CardOuterWrapper>
    </AbsoluteCardContainer>
  );
};

const Overlay = tw.div`absolute w-full h-full bg-[linear-gradient(180deg, #FFF 0%, #F6F7FF 100%)]`;

Layout.displayName = 'Layout';
Layout.Background = Background;
Layout.Card = LayoutCard;
Layout.Overlay = Overlay;

export { Layout };
